import { z } from "zod";
import { EmailSchema } from "./auth";

/**
 * `class-members` domain DTOs (Master Spec §33, Phase 12) — roster
 * management, kept separate from `classes.ts` per §33's own domain
 * list. Enrollment is by email, not by student id: a teacher managing a
 * roster knows a student's email (the same identifier they'd use to
 * look someone up anywhere else in this app), never their internal
 * UUID — mirrors `LoginRequestSchema`'s own `EmailSchema` reuse rather
 * than inventing a second email validator.
 */
export const AddClassMemberRequestSchema = z.object({
  classId: z.string().uuid(),
  email: EmailSchema,
});
export type AddClassMemberRequest = z.infer<typeof AddClassMemberRequestSchema>;

export const RemoveClassMemberRequestSchema = z.object({
  classId: z.string().uuid(),
  studentId: z.string().uuid(),
});
export type RemoveClassMemberRequest = z.infer<typeof RemoveClassMemberRequestSchema>;

export const ClassMemberDTOSchema = z.object({
  studentId: z.string().uuid(),
  email: EmailSchema,
  displayName: z.string(),
});
export type ClassMemberDTO = z.infer<typeof ClassMemberDTOSchema>;

export const AddClassMemberResponseSchema = z.object({
  member: ClassMemberDTOSchema,
});
export type AddClassMemberResponse = z.infer<typeof AddClassMemberResponseSchema>;

export const ListClassMembersResponseSchema = z.object({
  members: z.array(ClassMemberDTOSchema),
});
export type ListClassMembersResponse = z.infer<typeof ListClassMembersResponseSchema>;

export const RemoveClassMemberResponseSchema = z.object({
  success: z.literal(true),
});
export type RemoveClassMemberResponse = z.infer<typeof RemoveClassMemberResponseSchema>;

/** Querystring for `GET /api/v1/class-members?classId=...` — this codebase's first query-param-validated route. */
export const ListClassMembersQuerySchema = z.object({
  classId: z.string().uuid(),
});
export type ListClassMembersQuery = z.infer<typeof ListClassMembersQuerySchema>;
